import { render, staticRenderFns } from "./DealsByStatus.vue?vue&type=template&id=0fbdbac3&scoped=true&"
import script from "./DealsByStatus.vue?vue&type=script&lang=ts&"
export * from "./DealsByStatus.vue?vue&type=script&lang=ts&"
import style0 from "./DealsByStatus.vue?vue&type=style&index=0&id=0fbdbac3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbdbac3",
  null
  
)

export default component.exports